import { Injectable } from '@angular/core';
import { Promo } from '../models/promo.model';
import { LoggingService } from './LoggingService.service';
import { DataServices } from './data.services';
import { Sucursal } from '../models/sucursal.model';
import {Filter} from '../models/filter.model';
import {ReqVisit} from '../models/reqvisit.model';
import {ResultDTO} from '../models/resultdto.model';

@Injectable()
export class PromosService{


  promos: Promo[] = [];

  promosMobile: Promo[] = [];

  promo: Promo;

  sucursales: Sucursal[] = [];

  resultDTO: ResultDTO = new ResultDTO(-1, '');

  constructor(private loggingService: LoggingService, private dataServices: DataServices){}

  getPromos() {
    return this.dataServices.getPromos();
 }

 setPromos(promos: Promo[]) {
    this.promos =  promos;
    //this.loggingService.logMessage('PROMOS LIST SIZE: ' + promos.length);
 }


 setPromosMobile(promosMobile: Promo[]) {
  this.promosMobile =  promosMobile;
  //this.loggingService.logMessage('PROMOS LIST SIZE: ' + promosMobile.length);
}


 getPromosByPage(pageNumber: number) {
  return this.dataServices.getPromosByPage(pageNumber);
}


getPromosByCard(idCard: number) {
  return this.dataServices.getPromosByCard(idCard);
}

getPromosByCardPage(idCard: number, pageNumber: number) {
  return this.dataServices.getPromosByCardPage(idCard, pageNumber);
}

getPromoById(idPromo: number){
   return this.dataServices.getPromoById(idPromo);
}

setPromo(promo: Promo){
  this.promo=promo;
}

getBranchesByCity(idPromo: number, city: string){
  return this.dataServices.getBranchesByCity(idPromo, city);
}

setSucursales(sucursales: Sucursal[]){
  this.sucursales=sucursales;
}

getPromosByCardPageFilter(filter: Filter, pageNumber: number, pageSize: number) {
    return this.dataServices.getPromosByCardPageFilter(filter, pageNumber, pageSize);
  }

  getRelatedPromos(idCard: number, idPromo: number, idCliente: string) {
    return this.dataServices.getRelatedPromos(idCard, idPromo, idCliente);
  }

  recordVisit(reqVisit: ReqVisit) {

    return this.dataServices.recordVisit(reqVisit);
  }

  setResultDTO(resultDTO: ResultDTO){

    this.resultDTO = resultDTO;
  }

  getPromosByCamp(idCamp: number, pageNumber: number) {
    return this.dataServices.getPromosByCampPage(idCamp, pageNumber);
  }

  getPromosByCampAll(idCamp: number) {
    return this.dataServices.getPromosByCampPageAll(idCamp, 1);
  }

}
